import {useEffect} from 'react'

import {PURCHASE_ORDER_DETAIL_PAGE} from '../../common/constants/Pages.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {dispatch, useSelector} from '../../store.js'
import {getCurrentDetailPO} from './poDetailActions.js'
import {poIDSelector} from './poDetailSelectors.js'

export default function PODetailLocationListener() {
  const poID = useSelector(poIDSelector)

  useEffect(() => {
    if (!poID) {
      return
    }

    dispatch(setCurrentPage(PURCHASE_ORDER_DETAIL_PAGE))

    getCurrentDetailPO()
  }, [poID])

  return null
}
